import {
    deleteAllBookmarksFailure,
    getBookmarksFailure,
    getBookmarksSuccess,
    setBookmarkFailure,
    setBookmarkSuccess,
} from 'store/bookmarks/actions';
import { RequestStatus } from 'store/utils';

import {
    DELETE_ALL_BOOKMARKS_FAILURE,
    DELETE_ALL_BOOKMARKS_REQUEST,
    DELETE_ALL_BOOKMARKS_SUCCESS,
    GET_BOOKMARKS_FAILURE,
    GET_BOOKMARKS_REQUEST,
    GET_BOOKMARKS_SUCCESS,
    SET_BOOKMARK_FAILURE,
    SET_BOOKMARK_REQUEST,
    SET_BOOKMARK_SUCCESS,
} from './constants';
import { BookmarksState } from './reducer.types';

const initialState: BookmarksState = {
    getBookmarksRequest: {
        status: RequestStatus.IDLE,
        error: null,
        data: [],
    },
    setBookmarkRequest: {
        status: RequestStatus.IDLE,
        error: null,
    },
    deleteBookmarksRequest: {
        status: RequestStatus.IDLE,
        error: null,
    },
};

const handlers = {
    [GET_BOOKMARKS_REQUEST](state: BookmarksState): BookmarksState {
        return {
            ...state,
            getBookmarksRequest: {
                ...state.getBookmarksRequest,
                status: RequestStatus.PENDING,
            },
        };
    },
    [GET_BOOKMARKS_SUCCESS](
        state: BookmarksState,
        { payload: { bookmarks } }: ReturnType<typeof getBookmarksSuccess>,
    ): BookmarksState {
        return {
            ...state,
            getBookmarksRequest: {
                ...state.getBookmarksRequest,
                status: RequestStatus.SUCCESS,
                data: bookmarks,
            },
        };
    },
    [GET_BOOKMARKS_FAILURE](
        state: BookmarksState,
        { payload: { error } }: ReturnType<typeof getBookmarksFailure>,
    ): BookmarksState {
        return {
            ...state,
            getBookmarksRequest: {
                ...state.getBookmarksRequest,
                status: RequestStatus.FAILURE,
                data: [],
                error,
            },
        };
    },

    [SET_BOOKMARK_REQUEST](state: BookmarksState): BookmarksState {
        return {
            ...state,
            setBookmarkRequest: {
                ...state.setBookmarkRequest,
                status: RequestStatus.PENDING,
            },
        };
    },
    [SET_BOOKMARK_SUCCESS](
        state: BookmarksState,
        { payload: { bookmark } }: ReturnType<typeof setBookmarkSuccess>,
    ): BookmarksState {
        const updatedBookmarks = state.getBookmarksRequest.data.filter(
            ({ contentId, contentType }) =>
                contentId !== bookmark.contentId ||
                contentType !== bookmark.contentType,
        );
        updatedBookmarks.push(bookmark);

        return {
            ...state,
            setBookmarkRequest: {
                ...state.setBookmarkRequest,
                status: RequestStatus.SUCCESS,
            },
            getBookmarksRequest: {
                ...state.getBookmarksRequest,
                data: updatedBookmarks,
            },
        };
    },
    [SET_BOOKMARK_FAILURE](
        state: BookmarksState,
        { payload: { error } }: ReturnType<typeof setBookmarkFailure>,
    ): BookmarksState {
        return {
            ...state,
            setBookmarkRequest: {
                ...state.setBookmarkRequest,
                status: RequestStatus.FAILURE,
                error,
            },
        };
    },

    [DELETE_ALL_BOOKMARKS_REQUEST](state: BookmarksState): BookmarksState {
        return {
            ...state,
            deleteBookmarksRequest: {
                ...state.deleteBookmarksRequest,
                status: RequestStatus.PENDING,
            },
        };
    },
    [DELETE_ALL_BOOKMARKS_SUCCESS](state: BookmarksState): BookmarksState {
        return {
            ...state,
            deleteBookmarksRequest: {
                ...state.deleteBookmarksRequest,
                status: RequestStatus.SUCCESS,
            },
            getBookmarksRequest: {
                ...state.getBookmarksRequest,
                data: [],
            },
        };
    },
    [DELETE_ALL_BOOKMARKS_FAILURE](
        state: BookmarksState,
        { payload: { error } }: ReturnType<typeof deleteAllBookmarksFailure>,
    ): BookmarksState {
        return {
            ...state,
            deleteBookmarksRequest: {
                ...state.deleteBookmarksRequest,
                status: RequestStatus.FAILURE,
                error,
            },
        };
    },
};

export default { initialState, handlers };
